export const INVERSE_TIME = 'INVERSE_TIME';
export const UNITS_PER_MINUTE = 'UNITS_PER_MINUTE';
export const UNITS_PER_REVOLUTION = 'UNITS_PER_REVOLUTION';
